import { Report, ReportFilters, QueryResult } from '@/type';
import api from '@/API';

export default {
  find(id: number): Promise<Report> {
    return api
      .get(`reports/${id}`)
      .then(response => response.data);
  },
  findAll(clientId: number, filters: ReportFilters): Promise<QueryResult> {
    return api
      .get(`clients/${clientId}/reports`, { params: filters })
      .then(response => response.data);
  },
  async count(clientId: number, filters: ReportFilters): Promise<number> {
    const result = await this.findAll(clientId, filters);
    return result.total;
  },
};
